import { ApolloProvider } from '@apollo/client';
import '@fontsource/noto-sans/300.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/500.css';
import '@fontsource/noto-sans/600.css';
import '@fontsource/noto-sans/700.css';
import client from './src/apolloClient';
import LayoutRoot from './src/components/LayoutRoot';
import AuthUserProvider from './src/contexts/AuthUserContext';
import LocationLanguageProvider from './src/contexts/LocationLanguageContext';
import NovadeLiteUrlProvider from './src/contexts/NovadeLiteUrlContext';

export const wrapRootElement = ({ element }) => {
  return (
    <LocationLanguageProvider>
      <NovadeLiteUrlProvider>
        <ApolloProvider client={client}>
          <AuthUserProvider>
              <LayoutRoot>{element}</LayoutRoot>
          </AuthUserProvider>
        </ApolloProvider>
      </NovadeLiteUrlProvider>
    </LocationLanguageProvider>
  );
};
